import { ConnectionPositionPair } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  InjectionToken,
  Input,
  Output,
} from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
  positionPairs,
  OverlayPosition,
} from '../../core/overlay/overlay-directives';
import { DropdownItemComponent } from '../dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { IconHelpComponent } from '../icon-help/icon-help.component';
import { IconComponent } from '../icon/icon.component';
import { RtTooltip } from '../tooltip/tooltip.directive';

export interface IconHelpWithDropdownTranslations {
  clickForHelp: string;
  learnMore: string;
  contactSupport: string;
}

export const IconHelpWithDropdownTranslationsToken =
  new InjectionToken<IconHelpWithDropdownTranslations>('Translations for IconHelpWithDropdown');

@Component({
  selector: 'rt-icon-help-with-dropdown',
  templateUrl: 'icon-help-with-dropdown.component.html',
  styleUrls: ['./icon-help-with-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.with-padding]': 'withPadding',
    '[class.inline]': 'inline',
    '(click)': 'toggleDropdown()',
  },
  imports: [
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    IconComponent,
    IconHelpComponent,
    OverlayOriginDirective,
    RtTooltip,
    TranslatePipe,
  ],
})
export class IconHelpWithDropdownComponent {
  @Input() public link: string;
  @Input() public infoText: string;
  @Input() public contactSupport: boolean = false;
  @Input() public withPadding: boolean = false;
  @Input() public inline: boolean = false;
  @Input()
  public positions: ConnectionPositionPair[] = [
    positionPairs[OverlayPosition.BottomLeft],
    positionPairs[OverlayPosition.TopLeft],
  ];

  @Output() public readMoreClick: EventEmitter<void> = new EventEmitter();
  @Output() public openIntercom: EventEmitter<void> = new EventEmitter();

  public dropdownOpen: boolean = false;

  constructor(
    protected cdRef: ChangeDetectorRef,
    @Inject(IconHelpWithDropdownTranslationsToken)
    public translations: IconHelpWithDropdownTranslations,
  ) {}

  public toggleDropdown(state: boolean | undefined = undefined): void {
    this.dropdownOpen = state === undefined ? !this.dropdownOpen : state;
    this.cdRef.detectChanges();
  }

  public handleLinkClick(): void {
    this.toggleDropdown(false);
    this.readMoreClick.emit();
  }

  public openIntercomChat(): void {
    this.openIntercom.emit();
  }
}
